const Rub = {
  symbol: 'rub',
  color: '#000',
  plainIcon: c => {
    return `<path fill="${
      c ? c : this.color
    }" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm-5.5-16.762v1.808h1.764v2.608H10.5v1.705h1.764V25h1.988v-3.641h4v-1.705h-4v-2.608h2.509a7.91 7.91 0 0 0 2.26-.31c.696-.207 1.3-.52 1.814-.943.514-.421.92-.95 1.218-1.588.298-.637.447-1.386.447-2.247 0-.86-.14-1.6-.422-2.22-.282-.62-.671-1.133-1.168-1.537s-1.093-.706-1.789-.904A8.426 8.426 0 0 0 16.811 7h-4.547v8.238zm6.31 0h-2.558v-6.43h2.559c1.142 0 2.041.25 2.695.749.654.499.982 1.3.982 2.401 0 1.102-.328 1.924-.982 2.467-.654.542-1.553.813-2.695.813z" fill-rule="evenodd"/>`;
  },
  colorIcon() {
    return `<g fill="none" fill-rule="evenodd"><circle cx="16" cy="16" fill="#64d1ff" r="16"/><path d="M10.5 15.238h1.764V7h4.547c.844 0 1.614.099 2.31.297.696.198 1.292.5 1.789.904s.886.917 1.168 1.536c.281.62.422 1.36.422 2.221s-.15 1.61-.447 2.247a4.478 4.478 0 0 1-1.218 1.588 5.113 5.113 0 0 1-1.813.943 7.91 7.91 0 0 1-2.261.31h-2.51v2.608h4v1.705h-4V25h-1.987v-3.641H10.5v-1.705h1.764v-2.608H10.5zm6.31 0c1.143 0 2.042-.271 2.696-.813.654-.543.982-1.365.982-2.467 0-1.101-.328-1.902-.982-2.401-.654-.5-1.553-.75-2.695-.75h-2.56v6.431z" fill="#fff"/></g>`;
  }
};
export default Rub;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-cryptoicon/src/icons/rub.js
// module id = null
// module chunks = 